import React, {useState} from 'react'
import ErrorInfoComponent from "../../../../general/ErrorInfoComponent";
import FetchUtil from "../../../../../util/FetchUtil";
import ConfigUtil from "../../../../../util/ConfigUtil";
import DHDateTimePicker from "../../../../general/DHDateTimePicker";
import DHTextField from "../../../../general/DHTextField";
import DHButtonSave from "../../../../general/DHButtonSave";
import DHNumberTextField from "../../../../general/DHNumberTextField";


export default function TournamentCopyMultiComp({tournamentId, propBezeichnung, propBezeichnungKurz, onCopy}) {

    const [beginn, setBeginn] = useState(undefined);
    const [bezeichnung, setBezeichnung] = useState("[COPY] - " + propBezeichnung);
    const [bezeichnungKurz, setBezeichnungKurz] = useState(propBezeichnungKurz !== undefined && propBezeichnungKurz !== null && propBezeichnungKurz !== "" ? "[COPY] - " + propBezeichnungKurz : "");
    const [anzahl, setAnzahl] = useState(1);
    const [counter, setCounter] = useState(1);
    const [wiederholung, setWiederholung] = useState(0);

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const copyTournament = () => {
        setErrorMessage(undefined);
        let tmpBezeichnung = bezeichnung;
        let data = {bezeichnung:tmpBezeichnung,
            bezeichnungShort: bezeichnungKurz,
            anzahl: anzahl, counter: counter, wiederholungInTage: wiederholung,
            beginn: beginn};
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.tournament + "/multicopy/" + tournamentId,
            data,
            json => {
                setInfoMessage("Event wurde erfolgreich kopiert.");
                onCopy(json);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    const showSaveButton = () => {
        return !bezeichnung || !beginn;
    }

    return <>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)} />
        <div style={{padding: 20}}>
            <div style={{marginBottom: 10}}>
                Hier kannst du ein Event mehrfach kopieren.<br/>
                z.B. für fortlaufende Competitions usw.
            </div>
            <div style={{marginBottom: 20}}>
                Das Event wird genau mit den gleichen Daten angelegt und kann danach
                geändert werden.<br/>
                Sobald du in der Bezeichnung oder Kurzbezeichnung %COUNTER% einfügst, wird an dieser Stelle beim ersten kopierten Event der von dir gewählte Counter eingefügt, bei allen weiteren
                wird der Counter um eins erhöht.
            </div>
            <div style={{marginBottom: 20}}>
                Beispiel:<br/>
                Bezeichnung=Test %COUNTER%<br/>
                Anzahl Kopien=3<br/>
                Wiederholung in Tage=7<br/>
                Startzeitpunkt erstes Event=1.1.2025<br/>
                Am 01.01.,8.01 und 15.01 wird jeweils ein Event angelegt.<br/>
                Die Bezeichnung sind dann Test 1/Test2/Test3
            </div>
            <div style={{marginBottom: 10}}>
                <DHTextField id="id-bezeichnung" label="Bezeichnung" width="100%" required={true} value={bezeichnung} onChange={(text) => setBezeichnung(text)}/>
            </div>
            <div style={{marginBottom: 10}}>
                <DHTextField id="id-bezeichnung-kurz" label="Bezeichnung (kurz):" width="100%" required={false} value={bezeichnungKurz} onChange={(text) => setBezeichnungKurz(text)}/>
            </div>
            <div style={{marginBottom: 10}}>
                <DHNumberTextField id="id--anzahl" label="Anzahl Kopien:" min={1} width="100%" required={false} value={anzahl} onChange={(value) => setAnzahl(value)}/>
            </div>
            <div style={{marginBottom: 10}}>
                <DHNumberTextField id="id--counter" label="Counter:" min={0} width="100%" required={false} value={counter} onChange={(value) => setCounter(value)}/>
            </div>
            <div style={{marginBottom: 10}}>
                <DHNumberTextField id="id-wiederholung" label="Wiederholung in Tagen:" min={1} width="100%" required={false} value={wiederholung} onChange={(value) => setWiederholung(value)}/>
            </div>
            <div style={{marginTop: 20, marginBottom: 20}}>
                <DHDateTimePicker label="Startzeitpunkt erstes Event" disabled={false} value={beginn} changeValue={setBeginn}/>
            </div>
            <div style={{marginBottom: 20}}>
                Möchtest du die Events wirklich anlegen?
            </div>
            <div>
                <DHButtonSave working={false} disabled={showSaveButton()} onClick={() => copyTournament()}/>
            </div>
        </div>
    </>
}
